import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = ({ onNavigate }) => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const handleClick = (e, title) => {
    e.preventDefault();
    onNavigate('placeholder', title);
  };

  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-8">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © {currentYear} {t('header.siteName')}. {t('common.allRightsReserved')}
          </p>
          <div className="flex gap-6">
            <button
              onClick={(e) => handleClick(e, 'Privacy Policy')}
              className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
            >
              {t('common.privacyPolicy')}
            </button>
            <button
              onClick={(e) => handleClick(e, 'Terms of Use')}
              className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
            >
              {t('common.termsOfUse')}
            </button>
            <button
              onClick={(e) => handleClick(e, 'Contact Us')}
              className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
            >
              {t('common.contactUs')}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
